import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Clipboard Check Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-clipboard-check-outline',
    templateUrl: './icon-clipboard-check-outline.component.html',
    styleUrls: ['./icon-clipboard-check-outline.component.scss'],
    standalone: false
})
export class IconClipboardCheckOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
